"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODULE_NAME = void 0;

/**
 * @desc
 * Constant for module name.
 *
 * @type {String}
 */
var MODULE_NAME = 'skybase-ui';
exports.MODULE_NAME = MODULE_NAME;
//# sourceMappingURL=constants.js.map